<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageRegistrierkasseAT.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.pageRegistrierkasseAT.card.general')" cols="12 6@desktop start-1" rows="2">
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.pageRegistrierkasseAT.enabled')"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input-toggle :label="$t('admin.pageRegistrierkasseAT.rksvEnabled')"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           v-model="config.rksvEnabled"
                           cols="12 6@hd start-1"
                           name="rksvEnabled" />
          <hm-input-toggle :label="$t('admin.pageRegistrierkasseAT.startReceiptVerified')"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           v-model="config.startReceiptVerified"
                           cols="12 6@hd start-1"
                           name="startReceiptVerified" />
          <hm-input :label="$t('admin.pageRegistrierkasseAT.cashDeskId')"
                    :disabled="true"
                    v-model="config.cashDeskId"
                    cols="12 6@hd start-1"
                    name="cashDeskId">
            <template slot="icon-inline-right">
              <input-icon-button :border="true" :title="$t('reports.44294c85-9342-45c9-a702-fe024746fcf5')" icon="download" @click="downloadReport('44294c85-9342-45c9-a702-fe024746fcf5', [['cashDeskId', config.cashDeskId]])" />
              <input-icon-button :border="true" :title="$t('reports.9adb8480-ad4c-41b8-989f-7edf8bd58af8')" icon="download" @click="downloadDEP(null, config.cashDeskId)" />
            </template>
          </hm-input>
          <hm-input :label="$t('admin.pageRegistrierkasseAT.cashDeskIdSuffix')"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    v-model="config.cashBoxIdentificationSuffix"
                    cols="12 6@hd start-1"
                    name="cashBoxIdentificationSuffix" />
          <hm-input-number :label="$t('admin.pageRegistrierkasseAT.depId')"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           v-model="config.depId"
                           cols="12 6@hd start-1"
                           name="depId" />
          <hm-input :label="$t('admin.pageRegistrierkasseAT.aesKey')"
                    :disabled="true"
                    v-model="config.aesKey"
                    cols="12 6@hd start-1"
                    name="aesKey" />
          <hm-input :label="$t('admin.pageRegistrierkasseAT.aesKeyCheckSum')"
                    :disabled="true"
                    v-model="config.aesKeyCheckSum"
                    cols="12 6@hd start-1"
                    name="aesKeyCheckSum" />
        </hm-card-inner>
        <hm-card-inner>
          <template v-for="(it, idx) in config.historicCashDeskIds">
            <hm-input :label="$t('admin.pageRegistrierkasseAT.historicCashDeskId')"
                      :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                      v-model="config.historicCashDeskIds[idx]"
                      :key="idx"
                      lazy
                      cols="12 6@hd start-1"
                      name="historicCashDeskId">
              <template v-if="isValidCashDeskId(it)" slot="icon-inline-right">
                <input-icon-button :border="true" :title="$t('reports.44294c85-9342-45c9-a702-fe024746fcf5')" icon="download" @click="downloadReport('44294c85-9342-45c9-a702-fe024746fcf5', [['cashDeskId', it]])" />
                <input-icon-button :border="true" :title="$t('reports.9adb8480-ad4c-41b8-989f-7edf8bd58af8')" icon="download" @click="downloadDEP(null, it)" />
              </template>
            </hm-input>
          </template>
        </hm-card-inner>
      </card>
      <card :title="$t('admin.pageRegistrierkasseAT.card.receipt')" cols="12 6@desktop start-7@desktop" rows="start-1@desktop">
        <hm-card-inner>
          <hm-textarea :label="$t('admin.pageRegistrierkasseAT.receiptFooterLines')"
                       :disabled="!hasRole('ROLE_ADMIN')"
                       v-model="config.receiptFooterLines"
                       cols="12 6@hd start-1"
                       name="receiptFooterLines" />
        </hm-card-inner>
      </card>
      <card v-if="!isEmpty(config.aesKey) && !isNil(certificate)" :title="$t('admin.pageRegistrierkasseAT.card.financeAuthority')" cols="12 6@desktop">
        <hm-card-inner ref="cashDeskData" :full-size="true">
          <hm-col cols="12">
            <p style="font-family: monospace,monospace;font-size: 1.4rem;cursor: copy;padding: 1.5rem;" @click="copyCashDeskData">
              <b>Art der Sicherheitseinrichtung:</b> Hardware-Sicherheitsmodul (HSM) eines Dienstleisters<br/>
              <b>Vertrauensdienstanbieter (ZDA Id):</b> {{ certificate.zdaId }}<br/>
              <b>Seriennummer Hex:</b> {{ certificate.activeCertSerialNumber }}<br/>
              <b>Algorithmus:</b> {{ certificate.certificateList.find(it => it.serialNumberHex === certificate.activeCertSerialNumber).algorithm }}<br/>
              <b>Benutzerschlüssel AES-256:</b> {{ config.aesKey }}<br/>
              <b>Prüfwert für Benutzerschlüssel:</b> {{ config.aesKeyCheckSum }}<br/>
              <b>Kassenidentifikationsnummer:</b> {{ config.cashDeskId }}<br/>
            </p>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner>
          <hm-button v-if="!isNil(startReceiptPdfLink)"
                     cols="12@mobile 6"
                     class="btn--green btn--no-margin"
                     icon-left="download"
                     @click="downloadStartReceipt">{{ $t('admin.pageRegistrierkasseAT.actions.downloadStartReceipt') }}</hm-button>
        </hm-card-inner>
      </card>
      <card v-if="receipts != null"
            :title="$t('admin.pageRegistrierkasseAT.card.receipts')"
            :collapsed="receiptsCollapsed"
            cols="12"
            card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-table :hover="true"
                    min-width="400px"
                    columns="3"
                    grid-template-columns="2fr 4fr 1fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseAT.receipt.type') }}</div>
              <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseAT.receipt.dateTime') }}</div>
              <div class="hm-table__th">&nbsp;</div>
            </template>
            <template v-for="receipt in receipts">
              <div :key="`${receipt.id}-flag`" class="hm-table__td">
                <template v-for="flag in receipt.receipts[0].flags">{{ flag }} </template>
              </div>
              <div :key="`${receipt.id}-dateTime`" class="hm-table__td">{{ receipt.receipts[0].receiptDateTime | toDateTime }}</div>
              <div :key="`${receipt.id}-actions`" class="hm-table__td hm-table__td--icon">
                <span v-if="receipt.receipts[0].flags.includes('MonthReceipt') && receipt.receipts[0].additionalFields['EU_AT_MONTH'] % 3 === 0"
                      class="quick-action-button"
                      @click="downloadDEP(receipt)">
                  <icon icon="download" />
                </span>
                <span class="quick-action-button" @click="printReceipt(receipt.id, 0)">
                  <icon icon="printer" />
                </span>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
      <card v-if="!isEmpty(historicReceipts)"
            :title="$t('admin.pageRegistrierkasseAT.card.historicReceipts')"
            :collapsed="receiptsCollapsed"
            cols="12"
            card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-table :hover="true"
                    min-width="400px"
                    columns="4"
                    grid-template-columns="2fr 3fr 4fr 1fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseAT.receipt.type') }}</div>
              <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseAT.receipt.cashBoxId') }}</div>
              <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseAT.receipt.dateTime') }}</div>
              <div class="hm-table__th">&nbsp;</div>
            </template>
            <template v-for="receipt in historicReceipts">
              <div :key="`${receipt.id}-flag`" class="hm-table__td">
                <template v-for="flag in receipt.receipts[0].flags">{{ flag }} </template>
              </div>
              <div :key="`${receipt.id}-casBoxId`" class="hm-table__td">{{ receipt.receipts[0].cashDeskId }}</div>
              <div :key="`${receipt.id}-dateTime`" class="hm-table__td">{{ receipt.receipts[0].receiptDateTime | toDateTime }}</div>
              <div :key="`${receipt.id}-actions`" class="hm-table__td hm-table__td--icon">
                <span v-if="receipt.receipts[0].flags.includes('MonthReceipt') && receipt.receipts[0].additionalFields['EU_AT_MONTH'] % 3 === 0"
                      class="quick-action-button"
                      @click="downloadDEP(receipt, receipt.cashDeskId)">
                  <icon icon="download" />
                </span>
                <span class="quick-action-button" @click="printReceipt(receipt.id, 0)">
                  <icon icon="printer" />
                </span>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
    </template>
    <hm-floating-buttons v-if="config !== null && receipts != null">
      <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') && isEmpty(config.aesKey)"
                          :throttle="2500"
                          :label="$t('admin.pageRegistrierkasseAT.actions.createAESKey')"
                          icon="plus"
                          color="orange"
                          @click="createAESKey()" />
      <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') && !isEmpty(config.aesKey) && isEmpty(receipts)"
                          :throttle="30000"
                          :disabled="config.enabled === false"
                          :label="$t('admin.pageRegistrierkasseAT.actions.createStartReceipt')"
                          icon="plus"
                          color="orange"
                          @click="receiptAction('createStartReceipt')" />
      <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') && !isEmpty(config.aesKey) && !isEmpty(receipts)"
                          :throttle="30000"
                          :disabled="config.enabled === false"
                          :label="$t('admin.pageRegistrierkasseAT.actions.createSummaryReceipt')"
                          icon="plus"
                          color="blue"
                          @click="receiptAction('createSummaryReceipt')" />
      <hm-floating-button v-if="!isEmpty(config.aesKey) && !isEmpty(receipts)"
                          :throttle="30000"
                          :disabled="config.enabled === false"
                          :label="$t('admin.pageRegistrierkasseAT.actions.createNullReceipt')"
                          icon="plus"
                          color="blue"
                          @click="receiptAction('createNullReceipt')" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy, reverse, keyBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Reports from '@/lib/reports';
import { TimelineMax, TweenMax } from 'gsap';
import UpdateHotelSettingsMixin from '../../../mixins/UpdateHotelSettingsMixin';
import TimerMixin from '../../../mixins/TimerMixin';
import AutoAddNewRowsMixin from '../../../mixins/AutoAddNewRowsMixin';
import HmCardInner from '../../lib/layout/HmCardInner.vue';

export default {
  name: 'PageRegistrierkasseAT',
  components: { HmCardInner },
  mixins: [HotelmeisterMixin, SaveWatchMixin, TimerMixin, AutoAddNewRowsMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      fn: function (cbSaveComplete) {
        if (!this.hasRole('ROLE_ADMIN')) cbSaveComplete();

        const config = cloneDeep(this.config);
        if (!isEmpty(config.historicCashDeskIds)) config.historicCashDeskIds = config.historicCashDeskIds.filter(it => !isEmpty(it));

        this.axios.put(this.serviceUrls.registrierkasse.at.get(this, this.config.id), config)
          .then((response) => {
            this.config.cashDeskId = response.data.data.cashDeskId;
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      storedReceipts: null,
      certificate: null,
      receiptsCollapsed: true,
    };
  },

  computed: {
    reportsById: function () {
      return keyBy(Reports.list, 'id');
    },
    receipts: function () {
      if (this.storedReceipts == null) return null;
      return this.storedReceipts.filter(it => it.receipts.map(receipt => receipt.cashDeskId).includes(this.config.cashDeskId));
    },
    historicReceipts: function () {
      if (this.storedReceipts == null) return null;
      return this.storedReceipts.filter(it => !it.receipts.map(receipt => receipt.cashDeskId).includes(this.config.cashDeskId));
    },
    startReceipt: function () {
      if (this.receipts == null) return null;
      return this.receipts.find(it => it.receipts[0].flags.includes('StartReceipt'));
    },
    startReceiptPdfLink: function () {
      if (this.startReceipt == null) return null;

      return window.getOldUIPath(
        this.hotelSettings.tenant.subdomain,
        this.hotelSettings.hotel.id,
        `/rest/ui/backend/hotel/${this.$route.params.hotelId}/print/receipt?parentId=${this.config.hotelId}&receiptHolderId=${this.startReceipt.id}&receiptSeq=${0}&outputType=pdf`,
        window.getToken(this.$route.params.hotelId),
        null,
        true,
      );
    },
  },

  watch: {
    'config.historicCashDeskIds': {
      handler: function () {
        this.autoAddNewRows(
          this.config.historicCashDeskIds,
          null,
          it => isEmpty(it),
        );
      },
      deep: true,
    },
  },

  created: function () {
    this.loadData();
    this.setInterval(this.updateReceipts, 15000);
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isEmpty,
    isValidCashDeskId(cashDeskId) {
      if (isEmpty(cashDeskId)) return false;
      let referenceId = this.config.cashDeskId;
      referenceId = referenceId.substring(1);
      referenceId = referenceId.substring(0, referenceId.length - (this.config.cashBoxIdentificationSuffix || '').length);

      const comparison = cashDeskId.substring(1);
      return comparison.indexOf(referenceId) === 0;
    },
    downloadDEP(receipt, cashDeskId) {
      const params = [];
      if (!isEmpty(receipt)) {
        params.push(['year', receipt.receipts[0].additionalFields.EU_AT_YEAR]);
        params.push(['month', receipt.receipts[0].additionalFields.EU_AT_MONTH]);
      }
      if (!isEmpty(cashDeskId)) {
        params.push(['cashDeskId', cashDeskId]);
      }

      this.downloadReport('9adb8480-ad4c-41b8-989f-7edf8bd58af8', params);
    },
    downloadReport(reportId, params) {
      const report = this.reportsById[reportId];

      let url = `/rest/ui/backend${this.serviceUrls.report.legacy(this, report.legacy)}.html`;

      params.forEach((it) => {
        if (!isEmpty(it[0])) url = `${url}${url.includes('?') ? '&' : '?'}${it[0]}=${it[1]}`;
      });

      window.openOldUI(
        this.hotelSettings.tenant.subdomain,
        this.hotelSettings.hotel.id,
        url,
        window.getToken(this.$route.params.hotelId),
        this.$shortLocale === 'de' ? this.$shortLocale : 'en',
      );
    },
    printHTML(url) {
      this.$serviceBus.$emit('printHTML', url);
    },
    printReceipt(receiptHolderId, seq) {
      this.printHTML(
        window.getOldUIPath(
          this.hotelSettings.tenant.subdomain,
          this.hotelSettings.hotel.id,
          `/rest/ui/backend/hotel/${this.$route.params.hotelId}/print/receipt?parentId=${this.config.hotelId}&receiptHolderId=${receiptHolderId}&receiptSeq=${seq}`,
          window.getToken(this.$route.params.hotelId),
          null,
          true,
        ),
      );
    },
    loadData() {
      this.axios.get(this.serviceUrls.registrierkasse.at.get(this))
        .then((response) => {
          if (isNil(this.config)) {
            this.config = response.data.data;
          }
        });

      this.axios.get(this.serviceUrls.interfaces.aTrustRegMobile.get(this, null))
        .then((response) => {
          if (isNil(this.certificate)) {
            this.certificate = response.data.data;
          }
        });

      this.updateReceipts();
    },
    updateReceipts() {
      this.axios.get(this.serviceUrls.registrierkasse.at.listReceipts(this))
        .then((response) => {
          this.storedReceipts = reverse(response.data.data);
          if (this.storedReceipts == null) {
            this.storedReceipts = [];
          }
        });
    },
    createAESKey() {
      this.axios.post(this.serviceUrls.registrierkasse.at.createAESKey(this))
        .then((response) => {
          this.showSuccessMessage();
          this.config.aesKey = response.data.data.aesKey;
          this.config.aesKeyCheckSum = response.data.data.aesKeyCheckSum;
        })
        .catch(() => {
          this.showErrorMessage();
        });
    },
    receiptAction(action) {
      this.axios.post(this.serviceUrls.registrierkasse.at[action](this))
        .then((response) => {
          this.showSuccessMessage();
          this.receiptsCollapsed = false;
          this.updateReceipts();
          this.setTimeout(this.updateReceipts, 2500);
          this.setTimeout(this.updateReceipts, 5000);
        })
        .catch(() => {
          this.showErrorMessage();
        });
    },
    downloadStartReceipt() {
      window.open(this.startReceiptPdfLink, '_blank');
    },
    copyCashDeskData() {
      this.$copy(this.$refs.cashDeskData.$el.innerText);
      const el = this.$refs.cashDeskData.$el;
      const tl = new TimelineMax({
        onComplete: () => {
          el.style.boxShadow = null;
        },
      });
      tl.add(TweenMax.fromTo(el, 0.25, { backgroundColor: '#fff' }, { backgroundColor: '#bbdcd8' }));
      tl.add(TweenMax.fromTo(el, 0.5, { backgroundColor: '#bbdcd8' }, { backgroundColor: '#fff' }));
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageRegistrierkasseAT.vue